export const subtitles = {
    "1": {
        "startTime": 1.03,
        "endTime": 9.95,
        "transcript": "Yuunrillruuq agayulirtengqellemteńi [?Greens]-aamek. A long time.",
        "translation": "She passed away when our priest was [?Greens]. A long time."
    },
    "2": {
        "startTime": 11.691,
        "endTime": 19.823,
        "transcript": "Up'nerkami-ll' yuunrirluni Paaskaam nalliini nuliaqa wani.",
        "translation": "And my wife passed away in the spring around Easter."
    },
    "3": {
        "startTime": 20.857,
        "endTime": 23.19,
        "transcript": "Caullrua atra?",
        "translation": "What was her name?"
    },
    "4": {
        "startTime": 23.434,
        "endTime": 27.189,
        "transcript": "Elena. Elena Andrew.",
        "translation": "Elena. Elena Andrew."
    },
    "5": {
        "startTime": 28.05,
        "endTime": 28.961,
        "transcript": "Hunter?",
        "translation": "Hunter?"
    },
    "6": {
        "startTime": 28.986,
        "endTime": 31.853,
        "transcript": "Andrew. (Andrew?) Yaa.",
        "translation": "Andrew. (Andrew?) Yes."
    },
    "7": {
        "startTime": 34.682,
        "endTime": 36.238,
        "transcript": "Aa-ang.",
        "translation": "Yes."
    },
    "8": {
        "startTime": 44.849,
        "endTime": 53.427,
        "transcript": "Ciumek ayagyuallerpeni-qaa qasgimi uitaqallruuten?",
        "translation": "First, did you stay in the community house when you were young?"
    },
    "9": {
        "startTime": 54.057,
        "endTime": 58.146,
        "transcript": "Tamana qalamcikeqaqvgu.",
        "translation": "Please tell a story about that."
    },
    "10": {
        "startTime": 58.165,
        "endTime": 63.376,
        "transcript": "Waniw' ayagyuallemni qasgimi angturrillruunga.",
        "translation": "When I was young, I grew up in a community house."
    },
    "11": {
        "startTime": 63.378,
        "endTime": 68.878,
        "transcript": "Tua-llu iciw' aatama caniani qavarturatullruunga qasgimi.",
        "translation": "Then, you know, I would always sleep next to my father in the community house."
    },
    "12": {
        "startTime": 68.971,
        "endTime": 73.06,
        "transcript": "Yugugarni iciw', you know, qasgiq nallunritan.",
        "translation": "Among many people, you know, you about the community house."
    },
    "13": {
        "startTime": 73.091,
        "endTime": 79.558,
        "transcript": "[?Cuukvagtulirmi] pingqellruut. Qasgingqetullruut ingluktulput.",
        "translation": "There was one in [?Cuukvagtuli]. Our competitors had a community house."
    },
    "14": {
        "startTime": 79.93,
        "endTime": 82.975,
        "transcript": "Atama caniani.",
        "translation": "[I slept] next to my father."
    },
    "15": {
        "startTime": 83.461,
        "endTime": 94.172,
        "transcript": "Tua-i-llu quliini qavayarat waten inglengqetullruut two feet qasgit, two feet muragnek.",
        "translation": "Then the sleeping areas above had two feet beds like this in the community house, two feet of wood."
    },
    "16": {
        "startTime": 95.83,
        "endTime": 105.219,
        "transcript": "Tua-i-llu pinarianga cali atrarlua natermun, floor, nacitnun iciw' floor-amun.",
        "translation": "Then when it was time, I would go down to the nateq, floor, to the floor planks, you know, the floor."
    },
    "17": {
        "startTime": 105.363,
        "endTime": 108.685,
        "transcript": "Qavaraqluta tua-i camek pivkenata.",
        "translation": "We would sleep without thinking anything of it."
    },
    "18": {
        "startTime": 109.077,
        "endTime": 117.632,
        "transcript": "Aliimaksuaramteńek makucinek waten wall'u-q' imkunek Yupiartarnek aliimatpianek akicirluta qavaraqluta.",
        "translation": "We would sleep using these small mittens of ours like this, or those real Yup'ik gloves as headrests."
    },
    "19": {
        "startTime": 117.694,
        "endTime": 123.039,
        "transcript": "Cavkenani wangkutni wani ak'a tamaani, you know?",
        "translation": "It wasn't unusual to us a long time ago, you know?"
    },
    "20": {
        "startTime": 126.214,
        "endTime": 129.103,
        "transcript": "Tua-i tuaten yuullruukut.",
        "translation": "That's how we lived."
    },
    "21": {
        "startTime": 129.543,
        "endTime": 134.999,
        "transcript": "Wii apa'urluma anglicallruanga.",
        "translation": "My grandfather raised me."
    },
    "22": {
        "startTime": 135.102,
        "endTime": 140.235,
        "transcript": "Anglicarpek'nii waten: unuakumi qavarcecuitellruanga.",
        "translation": "He raised me like this: he wouldn't let me sleep in the morning."
    },
    "23": {
        "startTime": 141.308,
        "endTime": 146.564,
        "transcript": "Cunaw' tang elluarrlua yuusqellua pillrullinikiinga.",
        "translation": "It turned out that he had wanted me to live well."
    },
    "24": {
        "startTime": 146.988,
        "endTime": 152.965,
        "transcript": "Waten-llu qava'arqama waten, waten tupagyarturnauraanga waten ukugnun pilua.",
        "translation": "Then when I slept like this, he would come wake my up by doing this here."
    },
    "25": {
        "startTime": 154.759,
        "endTime": 162.57,
        "transcript": "Tua-i-ll' cailkamek maaken [?] pikanga, \"Ani patagmek qagaavet ellamun.\"",
        "translation": "Then when he [?] me from the floor her, he would say, \"Quickly go outside.\""
    },
    "26": {
        "startTime": 162.715,
        "endTime": 171.115,
        "transcript": "Ellami-gguq atam assiriqerrniartua. Ellamun ankuma assiriqerrluni ayuquciqa, cegg'arlua qavarniyugnairrlua.",
        "translation": "He said that I would get better outside. When I went outside, I would feel better, being awake with no more trace of sleep left."
    },
    "27": {
        "startTime": 171.376,
        "endTime": 178.243,
        "transcript": "Man'a-ll' tekilluku maa-i qavayuunii unuakumi wani kesianek [?].",
        "translation": "And to this day, I never sleep in the morning [?]."
    },
    "28": {
        "startTime": 178.443,
        "endTime": 181.081,
        "transcript": "Kass'atun qanraqlua pikuma.",
        "translation": "I should occassionally speak English."
    },
    "29": {
        "startTime": 183.89,
        "endTime": 184.912,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "30": {
        "startTime": 185.277,
        "endTime": 187.765,
        "transcript": "Nani tauna qasgi uitallrua?",
        "translation": "Where was that community house?"
    },
    "31": {
        "startTime": 187.766,
        "endTime": 191.355,
        "transcript": "Kayalivigmi. Kayalivigmi.",
        "translation": "In Kayalivik. In Kayalivik."
    },
    "32": {
        "startTime": 192.756,
        "endTime": 198.445,
        "transcript": "Ilangqellruuten-qaa amllernek ayagyuanek tuani qasgim iluani?",
        "translation": "Did you have a lot of young companions there in that community house?"
    },
    "33": {
        "startTime": 198.653,
        "endTime": 203.441,
        "transcript": "Amllertut. Ayagyuat qasgimi tau͡gaam uitatullruut.",
        "translation": "There were a lot. Young boys would only stay in the community house."
    },
    "34": {
        "startTime": 203.444,
        "endTime": 208.089,
        "transcript": "Qasgimi tua-i ayagyuat egkuani uitaaqluteng ayagyuat.",
        "translation": "In the community house, the youth would stay in the back wall."
    },
    "35": {
        "startTime": 208.364,
        "endTime": 213.953,
        "transcript": "Enemecuunateng. Ayagyuat tau͡gaam qasgimi uitasqumaluki, you know?",
        "translation": "They would stay in the houses. They wanted the youth to only stay in the community house, you know?"
    },
    "36": {
        "startTime": 214.01,
        "endTime": 221.454,
        "transcript": "Makut-llu tegganret maani, imkut-ll' angukara'urluut un'gani uaqvani, waten akiqliqluteng.",
        "translation": "These adults and the old men would be here toward the door, across from each other like this."
    },
    "37": {
        "startTime": 221.816,
        "endTime": 225.527,
        "transcript": "Tamakut tamaa-i qanrucitullruut yugnek waten.",
        "translation": "Those would speak to people like this."
    },
    "38": {
        "startTime": 225.535,
        "endTime": 227.813,
        "transcript": "Waten tutgarateng qanrutnaurait.",
        "translation": "They would speak to their grandchildren like this."
    },
    "39": {
        "startTime": 228.161,
        "endTime": 235.561,
        "transcript": "Tua-i-ll' qanruqaarluki, tutgaraq tuqlurluku qanruqaarluku qanpagaluteng. Alingnaqluteng qanpagaaqameng.",
        "translation": "Then after speaking to them, after one addressed and spoke to his grandchild, they would speak sternly. They would be scary when they spoke sternly."
    },
    "40": {
        "startTime": 235.623,
        "endTime": 240.645,
        "transcript": "Tau͡gken assilriameng qanerturluteng, qanerturatuluteng.",
        "translation": "Yet they would always speak about good things."
    },
    "41": {
        "startTime": 240.676,
        "endTime": 244.12,
        "transcript": "Ayuqucirtualuki qau͡gkut qavani egkumi.",
        "translation": "They would instruct the ones inside on the back wall."
    },
    "42": {
        "startTime": 244.595,
        "endTime": 247.339,
        "transcript": "Yaa, tuaten yuullruunga wiinga.",
        "translation": "Yes, that's how I lived."
    },
    "43": {
        "startTime": 251.385,
        "endTime": 254.307,
        "transcript": "Angutngurrlainaullrullilriit-wa qasgim iluani.",
        "translation": "They were probably all men in the community house."
    },
    "44": {
        "startTime": 254.313,
        "endTime": 257.968,
        "transcript": "Ii-i, yaa, tuaten anguterrlainaat pituut wani.",
        "translation": "Yes, yes, only men do that."
    },
    "45": {
        "startTime": 258.004,
        "endTime": 259.36,
        "transcript": "Tuamtellu...",
        "translation": "And then..."
    },
    "46": {
        "startTime": 264.142,
        "endTime": 277.809,
        "transcript": "Nasaurlucuaraat, nasaurlurraat angturiqerrluteng cali aatameng caniitni uitaurall'ernaurtut qasgimi qasgimiut niicugniurluki qalartellrat assilriamek.",
        "translation": "Little girls, little girls who had grown would also stay by their fathers in the community house listening to them speak about good things."
    },
    "47": {
        "startTime": 278.045,
        "endTime": 284.189,
        "transcript": "Tamakut tamaa-i ilait tuaten piqa'arqameng caqa'arqameng tuaten piuraraqluteng.",
        "translation": "When some of those did that, they would once in a while."
    },
    "48": {
        "startTime": 284.469,
        "endTime": 289.78,
        "transcript": "Una nasaurlucuar qasgimcugtura'aqluni.",
        "translation": "This little girl would keep wanting to be in the community house."
    },
    "49": {
        "startTime": 289.789,
        "endTime": 294.155,
        "transcript": "Cunaw' niicugluni qasgimiut qalartellritnek.",
        "translation": "Apparently, she wanted to hear what the men of the community house spoke about."
    },
    "50": {
        "startTime": 294.357,
        "endTime": 300.435,
        "transcript": "Yaa, angukara'urluut qalartellritnek. Yaa, tuaten pilallruut yuut.",
        "translation": "Yes, what the old men spoke about. Yes, that's what people would do."
    },
    "51": {
        "startTime": 300.782,
        "endTime": 307.682,
        "transcript": "Qaill' tamakut tegganret tamatum nalliini ayuqellruat?",
        "translation": "What were the adults like in that time?"
    },
    "52": {
        "startTime": 307.973,
        "endTime": 320.028,
        "transcript": "Tegganret tan'gaurlurnek tau͡gaam kitugcingnaqluteng yuullruut. Ayuqucirtuagurluki assirluki yuusqelluki.",
        "translation": "The adults lived only trying to improve boys. They instructed them, telling them to live well."
    },
    "53": {
        "startTime": 320.041,
        "endTime": 322.941,
        "transcript": "Kiingan tua-i caliaqaat tamana tegganret.",
        "translation": "That's the only job for adults."
    },
    "54": {
        "startTime": 323.376,
        "endTime": 331.576,
        "transcript": "Makut ilateng tan'gaurluut ayagyuat elluarrluki tau͡gaam yuusqelluki.",
        "translation": "They only wanted their relatives, these young boys, to live well."
    },
    "55": {
        "startTime": 331.749,
        "endTime": 337.005,
        "transcript": "Qanllerteng-llu cagesqevkenaku. Niitesqumaluteng kiinga.",
        "translation": "They did want what they said to be lost. The only wanted to be heard."
    },
    "56": {
        "startTime": 337.02,
        "endTime": 342.631,
        "transcript": "Assilriarrlainarnek qantullruut imkut angukara'urluut tangvallrenka wiinga.",
        "translation": "Those old men I watched would only speak of good things."
    },
    "57": {
        "startTime": 343.489,
        "endTime": 347.3,
        "transcript": "Yaa. Ii-i, igautaqluki.",
        "translation": "Yes. Yes, write them down."
    },
    "58": {
        "startTime": 350.732,
        "endTime": 351.999,
        "transcript": "Canek...",
        "translation": "What..."
    },
    "59": {
        "startTime": 364.487,
        "endTime": 367.164,
        "transcript": "Tang ata cukangnaqevkaavnga.",
        "translation": "You see, because you're making me hurry."
    },
    "60": {
        "startTime": 367.175,
        "endTime": 367.831,
        "transcript": "Nuu.",
        "translation": "No."
    },
    "61": {
        "startTime": 368.046,
        "endTime": 375.291,
        "transcript": "Igaqautaqluki, igaulluki, ayagnerit-llu ayagluki nallunritarkaukuvki elisngakuvet tua-i.",
        "translation": "Write them down, and start from the beggining if you are to know them if you are smart."
    },
    "62": {
        "startTime": 375.82,
        "endTime": 378.909,
        "transcript": "Ayagneritnek tua-i-ll' taringluku.",
        "translation": "From the beginning, then you'll understand."
    },
    "63": {
        "startTime": 379.594,
        "endTime": 383.405,
        "transcript": "Tua-ll' tamakut... are we ready?",
        "translation": "Then those... are we ready?"
    },
    "64": {
        "startTime": 383.54,
        "endTime": 390.662,
        "transcript": "Tamakut-qaa tegganret mat'um nalliinicetun ayuqellruut wall'u-qaa?",
        "translation": "Were those adults like how they are now, or what?"
    },
    "65": {
        "startTime": 391.444,
        "endTime": 394.084,
        "transcript": "Nuu, mat'um nalliinicetun ayuqenritut.",
        "translation": "No, they weren't like how they are now."
    },
    "66": {
        "startTime": 394.096,
        "endTime": 402.818,
        "transcript": "Tua-i-w' anailameng, camek-llu uitavigkailameng, quyungqanriameng waten caggluteng pingengameng enemeggni.",
        "translation": "It's because they don't go out, and they have no place, because they are not gathered anymore, but scattered in their houses like this."
    },
    "67": {
        "startTime": 403.306,
        "endTime": 415.995,
        "transcript": "Wii tau͡gaam kiima waniwa maani arenqilriit ilanka wall'u-q' ilakenrilengramki tan'gaurluut qalaruquralaranka carraquinermek tua-i niitarkaatnek.",
        "translation": "Now, only I speak to the boys, my relatives, or even if they're not my relatives, who do well [to come] a little about what they need to hear."
    },
    "68": {
        "startTime": 416.009,
        "endTime": 417.243,
        "transcript": "Tua-i niilluki.",
        "translation": "They listen to them."
    },
    "69": {
        "startTime": 417.247,
        "endTime": 429.669,
        "transcript": "Maa-i-ll' mat'um nalliini ilait au͡gkut inerciigatellret qalaruquratullrenka egmian tua-i assiriluteng, assirluteng.",
        "translation": "And these days, some of the ones who were mischievous whom I spoke to get better right away, are better."
    },
    "70": {
        "startTime": 429.873,
        "endTime": 437.996,
        "transcript": "Aklungluteng-llu, cangluteng tua-i, qaqicimariluteng tua-i, arenqiallugtenrirluteng.",
        "translation": "They get clothes, get things, have everything they need, no longer in misfortune."
    },
    "71": {
        "startTime": 438.64,
        "endTime": 444.985,
        "transcript": "Canek, canek tamakut tegganret elicalallruitki ayagyuat?",
        "translation": "What would those adults teach the youth?"
    },
    "72": {
        "startTime": 446.284,
        "endTime": 451.084,
        "transcript": "Ayagallerkaatnek elicalallruit, imarpigmun-ll' ayagalallerkaat.",
        "translation": "They would teach how they would travel, and how they would travel in the ocean."
    },
    "73": {
        "startTime": 451.094,
        "endTime": 457.405,
        "transcript": "Tua-i ayagalallerkaat tamalkuan elitnaurluki qalaruqu'urluki pitullruit.",
        "translation": "They would always speak to them to teach them everything about traveling."
    },
    "74": {
        "startTime": 460.156,
        "endTime": 461.989,
        "transcript": "Tuaten pitullruut.",
        "translation": "That's what they'd do."
    },
    "75": {
        "startTime": 462.125,
        "endTime": 472.614,
        "transcript": "Ayakatalriit tua-i tuaten qanrulluki tua-i. Tuaten yuilqumi arenqiallugeskaku-llu tuaten pisqelluku. Tuaten pilallruitkut.",
        "translation": "They would speak to those we were going to travel like. They even told them what they would do if they came to misfortune in the wilderness. That's how they [taught] us."
    },
    "76": {
        "startTime": 474.684,
        "endTime": 477.45,
        "transcript": "Elitnaulriacetun?",
        "translation": "Like going to school?"
    },
    "77": {
        "startTime": 477.465,
        "endTime": 479.043,
        "transcript": "Ii-i, elitnaulriacetun.",
        "translation": "Yes, like going to school."
    },
    "78": {
        "startTime": 479.052,
        "endTime": 484.019,
        "transcript": "Tua-i-llu wangkuta Yupiaruamta",
        "translation": "And then because we're Yup'ik"
    },
    "79": {
        "startTime": 486.417,
        "endTime": 497.517,
        "transcript": "Tua-i-wa neqkailkumta-llu wall'u pikangqerqumta, pikangqerqumta camek neqkailkumta, qassatukatgu tua-i qassarluku ner'arkauluku.",
        "translation": "And if we have no other food, if we have something with no other food, if they eat it raw, we must eat it raw."
    },
    "80": {
        "startTime": 498.326,
        "endTime": 504.193,
        "transcript": "Tua-i-llu tuaten waniw' ayuqucirtulallruitkut waten:",
        "translation": "Then they would instruct us like this:"
    },
    "81": {
        "startTime": 504.277,
        "endTime": 515.055,
        "transcript": "Ayakataqumta carrarmek neqrarmek, cakuine'rmek ayaulluta ayaasqelluta.",
        "translation": "If we're going to travel, they told us to travel with a little food, a little scrap."
    },
    "82": {
        "startTime": 515.314,
        "endTime": 521.359,
        "transcript": "Qanikciurun-llu imna shovel malikerrlainarluku.",
        "translation": "And we should always bring a shovel with us."
    },
    "83": {
        "startTime": 521.376,
        "endTime": 523.276,
        "transcript": "Cali-llu qilak.",
        "translation": "Also some cloth to work with."
    },
    "84": {
        "startTime": 523.291,
        "endTime": 531.203,
        "transcript": "Wiinga ellangellruama tua-i lumarrat amlleriluki qiliggarkaq tua-i malikerrlainarluku.",
        "translation": "Since I grew up with an increase of cloth, I always took cloth to work with with me."
    },
    "85": {
        "startTime": 531.218,
        "endTime": 534.673,
        "transcript": "Neqraq-llu cali malikerrlainarluku.",
        "translation": "And always bring fishing tools with us."
    },
    "86": {
        "startTime": 535.053,
        "endTime": 540.997,
        "transcript": "Tua-i-llu ellaqerruskakut egmian cali ayangnaqesqevkenata.",
        "translation": "Then if the weather turns on us, they told us not to travel right away either."
    },
    "87": {
        "startTime": 541.011,
        "endTime": 545.689,
        "transcript": "Egmian ayagturaasqevkenata tua-i umyuaqellemtun.",
        "translation": "They told us not to travel right away as we think to."
    },
    "88": {
        "startTime": 545.702,
        "endTime": 559.18,
        "transcript": "Tau͡gaam arulairesqelluta uqinrunrilngurmun waten, waten imna iciw' nuna, man'a nuna.",
        "translation": "Instead, they told us to stop where we're not shielded [from the wind] liek this, you know, the land like this, the land here."
    },
    "89": {
        "startTime": 560.132,
        "endTime": 567.032,
        "transcript": "Wani wavet qanikcanrilkaku tua-i waten alaunaku waten.",
        "translation": "If it hadn't snowed here, and it was visible like this."
    },
    "90": {
        "startTime": 567.234,
        "endTime": 573.611,
        "transcript": "Tua-i tuaten arulairesqelluta, qilaput tuaten pisqelluku elliqerluku.",
        "translation": "They told us to stop like that, and even to set up our tent."
    },
    "91": {
        "startTime": 574.405,
        "endTime": 583.228,
        "transcript": "Tua-i-ll' cali caitqapigeskumta qilagkamek cali qanikcaq nayugluku waten.",
        "translation": "Then if we have absolutely no tent, we should hollow out the snow like this."
    },
    "92": {
        "startTime": 583.235,
        "endTime": 587.335,
        "transcript": "Eneliluta waten nayugluku, iterluta.",
        "translation": "Make a space hollowing it out like this, then go in."
    },
    "93": {
        "startTime": 587.848,
        "endTime": 599.248,
        "transcript": "Tau͡gaam cam uqinermun pivkenata cali nuna man'a im' maa-i tua-i tuavet qanikcaq nayuulluku tua-i iterluta.",
        "translation": "But we shouldn't go into the leeward side in the land here, but hollow out the snow there and go in."
    },
    "94": {
        "startTime": 599.287,
        "endTime": 605.054,
        "transcript": "Qulvut-llu una waten ukilluku aneryaarcuutekluku.",
        "translation": "And poke a hole above us like this as a breathing hole."
    },
    "95": {
        "startTime": 605.201,
        "endTime": 610.568,
        "transcript": "Qanikcaam atam makuni epsal[ngunarqucia] cakneq nallunritaqa wiinga.",
        "translation": "You see, I absolutely know that snow is suffocating."
    },
    "96": {
        "startTime": 611.238,
        "endTime": 612.159,
        "transcript": "Atuqallruan?",
        "translation": "Have you ever experienced it?"
    },
    "97": {
        "startTime": 612.159,
        "endTime": 616.025,
        "transcript": "Yaa, atuqallruaqa. Epsalngunarquq. Kiircetuq cakneq.",
        "translation": "Yes, I've experienced it. It's suffocating. It's very hot."
    },
    "98": {
        "startTime": 616.136,
        "endTime": 622.703,
        "transcript": "Epciquq yuk tuquluni-ll' tua-i tuaten qanrucimanrilkuni.",
        "translation": "A person will suffocate and die if he's not told about that."
    },
    "99": {
        "startTime": 622.719,
        "endTime": 625.841,
        "transcript": "Epsalngunarquq, tuquluni-ll' tua-i.",
        "translation": "It's suffocating, then he dies."
    },
    "100": {
        "startTime": 627.002,
        "endTime": 630.513,
        "transcript": "Alingnarquq qanikcaq tamana wani.",
        "translation": "That snow is dangerous."
    },
    "101": {
        "startTime": 631.698,
        "endTime": 639.032,
        "transcript": "Cali kiskuvet, wiinga cali atullruaqa killua maatekiirlua waten.",
        "translation": "Also, if you sink, I also experienced sinking to here like this."
    },
    "102": {
        "startTime": 640.541,
        "endTime": 644.614,
        "transcript": "Quunirluni ella nengllirluni-ll' pacelluku waten.",
        "translation": "The weather was calm, and it was cold and chilly like this."
    },
    "103": {
        "startTime": 644.63,
        "endTime": 653.208,
        "transcript": "Nuliaqa-w' unilluku irniagka-llu pissurlua, hunting [?], imarmiutarnek.",
        "translation": "I left my wife and children to go hunt, hunting, for minks."
    },
    "104": {
        "startTime": 653.369,
        "endTime": 661.058,
        "transcript": "Tua-i-llu man'a imarmiutacuar allayugtun pilria qamurturluni tua-i",
        "translation": "Then this small mink that was acting strangely was dragging"
    },
    "105": {
        "startTime": 661.076,
        "endTime": 665.943,
        "transcript": "Uumek piluni tallirluni, uumek kat'umek-llu iruluni.",
        "translation": "It had its forepaws here, and its hindpaws were down there."
    },
    "106": {
        "startTime": 665.952,
        "endTime": 671.474,
        "transcript": "Tamatumek paqnayullemni kit'ellruunga. Tam'a'rqurluku tum'arrluku.",
        "translation": "When I was curious about that, I sank. I followed its tracks."
    },
    "107": {
        "startTime": 671.488,
        "endTime": 674.577,
        "transcript": "Nunapik-wa una nunapik.",
        "translation": "The tundra here was here."
    },
    "108": {
        "startTime": 675.64,
        "endTime": 678.495,
        "transcript": "Man'a cikuuluni.",
        "translation": "This part was ice."
    },
    "109": {
        "startTime": 678.545,
        "endTime": 683.145,
        "transcript": "Tua-i tamana waten ayarungqerrsaaqlua, ayarurlua.",
        "translation": "There, I did have a staff, I used my staff."
    },
    "110": {
        "startTime": 683.387,
        "endTime": 690.654,
        "transcript": "Tamatumek paqnayuglua piinanemni nunapiar waniw' tekiteqatarluku igtua man'a-ll' tekilluku.",
        "translation": "As I was curious about that, when I was going to reach the tundra here, I fell and it reached here."
    },
    "111": {
        "startTime": 691.914,
        "endTime": 694.714,
        "transcript": "Nengllirluni-ll' qakemna.",
        "translation": "And it was cold out there."
    },
    "112": {
        "startTime": 695.491,
        "endTime": 700.502,
        "transcript": "Kenrenka wani plastic-aamek caqumaurluteng uitaluteng.",
        "translation": "And my matches were here, covered in plastic."
    },
    "113": {
        "startTime": 701.058,
        "endTime": 713.091,
        "transcript": "Tua-i-llu takelriignek-llu waten pilua kamksagnek ayagassuutegnek-wa imkunek.",
        "translation": "And I also had long fur boots like this, the ones used for traveling."
    },
    "114": {
        "startTime": 714.044,
        "endTime": 715.321,
        "transcript": "Killua.",
        "translation": "I sunk."
    },
    "115": {
        "startTime": 715.337,
        "endTime": 722.914,
        "transcript": "Maaten kic'ama kamqertevkenii au͡gna ciunerkaqa kauka'rqa.",
        "translation": "When I sunk, it didn't reach past my boods, and I poked where I would go."
    },
    "116": {
        "startTime": 723.11,
        "endTime": 730.788,
        "transcript": "Waniw' tua-i tekiciiqellinikeka man'a kiturpailemku nunaq.",
        "translation": "I would reach the land before [the water] would go here."
    },
    "117": {
        "startTime": 730.878,
        "endTime": 733.289,
        "transcript": "Tua-i-ll' taglua.",
        "translation": "Then I went on the land."
    },
    "118": {
        "startTime": 733.581,
        "endTime": 738.748,
        "transcript": "Mayurlua tua-i ivrarlua. Tua-i kisngang'e'rmi taglua tua-i.",
        "translation": "I went up wading. Though I had sunk, I went up on land."
    },
    "119": {
        "startTime": 738.783,
        "endTime": 745.827,
        "transcript": "Mayuama-ll' egmian aturanka yuulaagluki tua-i patagpiarlua quunian-llu ella nenglling'e'rmi.",
        "translation": "When I went up, I quickly took off my clothes in great hurry because the weather was calm though it was cold."
    },
    "120": {
        "startTime": 746.157,
        "endTime": 753.568,
        "transcript": "Ciulaagluki tamalkuita. Imkuk kameksak kuvluku waten-llu piaqlukek waten.",
        "translation": "I quickly wrung them all. I poured the water out of my fur boots and would do this."
    },
    "121": {
        "startTime": 754.512,
        "endTime": 763.112,
        "transcript": "Tua-i-ll' can'get amllerrata egmian aturalaagma canegnek tua-i man'a keviraqluku.",
        "translation": "Then because there was a lot of grass, right when I put on my clothes, I stuffed grass in here."
    },
    "122": {
        "startTime": 763.219,
        "endTime": 767.441,
        "transcript": "Can'get pingualuruki ukumnun piaqluki, ukumnun piaqluki.",
        "translation": "I bunched grass and put them here, put them here."
    },
    "123": {
        "startTime": 767.883,
        "endTime": 773.583,
        "transcript": "Tua-i-ll' taq'ercamki maaten kiartua qakineyagaat makut.",
        "translation": "Then when I was done with them, I looked around and noticed pale dry dead wood."
    },
    "124": {
        "startTime": 774.141,
        "endTime": 779.185,
        "transcript": "Imkut qakinret, you know iciw' muraketukeput.",
        "translation": "Those dry dead wood, you know, the ones we use for woodwork."
    },
    "125": {
        "startTime": 779.937,
        "endTime": 788.159,
        "transcript": "Tua-i-ll' caaniggangqerrama puqlassuutet-ll' amllerivailgata, puqlissuutet imkut pingvailgata",
        "translation": "Then since I had a small kettle before there were a lot of portable stoves, before there were portable stoves"
    },
    "126": {
        "startTime": 789.186,
        "endTime": 795.042,
        "transcript": "Keneq kumarrluku tuaken imuken mecungenrilriani wani kenernek, kenpianek.",
        "translation": "I lit the fire with the matches from here that were no longer wet, real mathes."
    },
    "127": {
        "startTime": 795.045,
        "endTime": 797.445,
        "transcript": "Kenpianek waten [?].",
        "translation": "[?] real matches like this."
    },
    "128": {
        "startTime": 798.253,
        "endTime": 801.619,
        "transcript": "Kumarrluku tua-i kenilua caanililua.",
        "translation": "I started a fire and made a kettle of hot water."
    },
    "129": {
        "startTime": 801.622,
        "endTime": 806.589,
        "transcript": "Tua-i puqlangan caayumek tua-i yuurqaqcaarlua.",
        "translation": "When it got hot, I sipped some tea."
    },
    "130": {
        "startTime": 806.746,
        "endTime": 811.713,
        "transcript": "Piama uruglua. Uruglua tua-i man'a nenglliurallra urugluku.",
        "translation": "When I did, I warmed up. I warmed up from this cold."
    },
    "131": {
        "startTime": 811.727,
        "endTime": 814.894,
        "transcript": "Tua-ll' taqngama umyuartequa.",
        "translation": "Then when I was done, I pondered."
    },
    "132": {
        "startTime": 815.063,
        "endTime": 823.041,
        "transcript": "Tua-i-llu yuurqallma kinguani makuk irugka puqlangengiinartuk imkuk tua-i canegnek imillregka",
        "translation": "Then after I had tea, my legs started getting warmer, the ones that I filled with grass"
    },
    "133": {
        "startTime": 823.816,
        "endTime": 827.76,
        "transcript": "Man'a tekilluku tua-i kiturluku-llu.",
        "translation": "Reaching here and past it."
    },
    "134": {
        "startTime": 828.739,
        "endTime": 837.717,
        "transcript": "Wii piyuagurlua pitullruama qimugcilleq, pitengnaqaqama-gga qimugcilleq assiksuitellruamku.",
        "translation": "I always used to walk because I didn't like mushing dogs when I was hunting."
    },
    "135": {
        "startTime": 838.988,
        "endTime": 844.488,
        "transcript": "Tua-i-llu ayaglua naspaalua.",
        "translation": "Then I tried traveling."
    },
    "136": {
        "startTime": 844.491,
        "endTime": 849.379,
        "transcript": "Tua-i waniw' qerruyingkanga utertarkaulua.",
        "translation": "Should I've gotten cold, I'd have to go home."
    },
    "137": {
        "startTime": 849.765,
        "endTime": 860.877,
        "transcript": "Ernerpak piyuagua puqelvangluni. Kiiryunglua tua-i kiiryuglua. Cukangssaagarpek'nii.",
        "translation": "I walked all day and [my legs] got very warm. I got very hot. I didn't go quickly."
    },
    "138": {
        "startTime": 860.882,
        "endTime": 870.615,
        "transcript": "Imkut yaaqsilriit pissuutenka imkut iciw' kapkaanat tekilluki nangluki uterrlua-llu.",
        "translation": "I went to every one of my far away tools, you know, those steel traps, and went home."
    },
    "139": {
        "startTime": 870.676,
        "endTime": 873.565,
        "transcript": "Uterrlua-ll' qaillun nenglliu...",
        "translation": "And I went home in the cold..."
    },
    "140": {
        "startTime": 873.573,
        "endTime": 882.806,
        "transcript": "Tua-i tang yuut imkut alerquutait assilriit cakneq, imkut ciuqlirmi ciuliarit.",
        "translation": "You see, the instructions of those people back then are old, their first ancestors."
    },
    "141": {
        "startTime": 882.817,
        "endTime": 885.672,
        "transcript": "Waniw' ciuliatgun wii yuugua.",
        "translation": "I am living according to the ancestors."
    },
    "142": {
        "startTime": 886.451,
        "endTime": 895.163,
        "transcript": "Waniw' yuugarkaugukut usvitungnaqelriani ciuliaput ak'a tamaanillaat aturluki.",
        "translation": "Now, we who are trying to be mindful must live according to our ancestors' wisdom of long ago."
    },
    "143": {
        "startTime": 895.446,
        "endTime": 900.868,
        "transcript": "Elluarrluta yuuciqukut tuaten yuukumta ciuliaput aturluki.",
        "translation": "We will live well if we live according to our ancestors like that."
    },
    "144": {
        "startTime": 901.53,
        "endTime": 904.708,
        "transcript": "Tua-i-wa tuaten ayuquq.",
        "translation": "Well, that's how it is."
    },
    "145": {
        "startTime": 905.139,
        "endTime": 908.306,
        "transcript": "Ii-i, aptaqlua camek tua-i piyugaqavnga.",
        "translation": "Okay, ask me something whenever you want."
    },
    "146": {
        "startTime": 910.117,
        "endTime": 923.039,
        "transcript": "Ilait tegganrurtellriit maa-i-rpak, ilait tegganrutellriit maa-i-rpak qanlartut, ak'a-gguq tamaani tegganret, yuut imkut naulluyuitellruut. Tamana-qaa piciuguq?",
        "translation": "Some who are elders now, some who are elders now say that a long time ago, elders, people would not get sick. Is that true?"
    },
    "147": {
        "startTime": 923.049,
        "endTime": 924.337,
        "transcript": "Yaa, piciuguq.",
        "translation": "Yes, it's true."
    },
    "148": {
        "startTime": 924.415,
        "endTime": 928.248,
        "transcript": "Naulluuyuitellruut imkut yuut wani.",
        "translation": "People didn't get sick back then."
    },
    "149": {
        "startTime": 928.673,
        "endTime": 933.751,
        "transcript": "Cayaqliqapiarluni tang atauciq naulluulalria.",
        "translation": "Once in a great while, you see, one person would get sick."
    },
    "150": {
        "startTime": 934.197,
        "endTime": 938.975,
        "transcript": "Iliini-ll' allrakurtaqluni, one year.",
        "translation": "And sometimes one year would pass."
    },
    "151": {
        "startTime": 939.438,
        "endTime": 945.472,
        "transcript": "Tua-i-ll' iliini tuquarkaullinikuni tua-i tuquyaqlirluni tuquluni.",
        "translation": "Then sometimes if one is to die, he would be the first to die in a long time."
    },
    "152": {
        "startTime": 945.485,
        "endTime": 952.096,
        "transcript": "Tau͡gken tua-i tamana pellugluku cali iliini talliriluni tua-i tuaten.",
        "translation": "Yet after that had passed, sometimes five years would pass [with no deaths] like that."
    },
    "153": {
        "startTime": 952.131,
        "endTime": 958.987,
        "transcript": "Cali-llu TB-lriit ikgenateng, TB.",
        "translation": "And there were few who had TB."
    },
    "154": {
        "startTime": 960.997,
        "endTime": 966.852,
        "transcript": "Tua-i TB-lriit inerquutaqluki waten mallguri[sqevkenaki].",
        "translation": "They admonish people against getting close to those with TB."
    },
    "155": {
        "startTime": 967.153,
        "endTime": 975.819,
        "transcript": "Makut-am inerquutaqsagutait Kass'at. Wangkuta TB-lriit waten pingraata cikiyuitaitkut.",
        "translation": "Caucasians have started admonishing against this. Though we do this to those with TB, they don't give it to us."
    },
    "156": {
        "startTime": 979.01,
        "endTime": 985.833,
        "transcript": "Cikiringaituq yuk apquciminek, you know?",
        "translation": "A pesron will not spread his ailment, you know?"
    },
    "157": {
        "startTime": 986.162,
        "endTime": 993.918,
        "transcript": "Tuaten ayuqelria umyuarteqelia camek uluryagpek'nani elluarrluni yuuciquq, camek, cam-llu agtuyuunaku.",
        "translation": "One who is and thinks like that without being wary will live well, and nothing will touch him."
    },
    "158": {
        "startTime": 994.707,
        "endTime": 995.652,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "159": {
        "startTime": 996.035,
        "endTime": 1001.146,
        "transcript": "Agtuyuunaku-ll' yuum ca uluryakevkenaku qanrutkengraatgu.",
        "translation": "Nothing will touch him if he's not wary though they tell him."
    },
    "160": {
        "startTime": 1002.153,
        "endTime": 1009.342,
        "transcript": "Waniw' tuaten wii yuugua alerquutemnek cali atamnek apa'urlumnek-llu.",
        "translation": "Now, I am living like that through the instruction passed down to me by my father and grandfather."
    },
    "161": {
        "startTime": 1013.249,
        "endTime": 1023.905,
        "transcript": "Tua-ll' ak'a tamaani-qaa tegganret ukvengqelallruut, camek-llu ukvengqelallruat?",
        "translation": "Then, a longt ime ago, did the elders have beliefs, and what were their beliefs?"
    },
    "162": {
        "startTime": 1023.917,
        "endTime": 1027.962,
        "transcript": "Angalkunek. Kiingan angalkuq.",
        "translation": "Shamans. Only a shaman."
    },
    "163": {
        "startTime": 1027.992,
        "endTime": 1032.647,
        "transcript": "Imna-llu iciw' Agayun-llu nalluluku, imna agayulirta.",
        "translation": "And, you know, they didn't know God, that priest."
    },
    "164": {
        "startTime": 1033.159,
        "endTime": 1044.181,
        "transcript": "Wii tamaani ellangellemni mission-aat tekitelallruut Kayalivigmun waten Cuukvagtuli-ll' ingluku[llutek].",
        "translation": "Back when I was growing up, missions would arrive to Kayalivik where they would compete with Cuukvagtuli."
    },
    "165": {
        "startTime": 1044.208,
        "endTime": 1052.575,
        "transcript": "Egmian tua-i yurarturluta-ll' waten piqtaarluta, waten piqtaarluta, waten piqtaarturluta every year, every year too.",
        "translation": "Right away, we would dance back and for like this, back and forth like this, back and forth like this every year, every year too."
    },
    "166": {
        "startTime": 1053.53,
        "endTime": 1056.163,
        "transcript": "Tuaten pituluteng.",
        "translation": "They would do that."
    },
    "167": {
        "startTime": 1057.899,
        "endTime": 1059.966,
        "transcript": "Camek-mi ukvengqellruat?",
        "translation": "But what was their belief?"
    },
    "168": {
        "startTime": 1059.971,
        "endTime": 1060.482,
        "transcript": "Ai?",
        "translation": "What?"
    },
    "169": {
        "startTime": 1060.499,
        "endTime": 1062.843,
        "transcript": "Camek ukvengqellruat?",
        "translation": "What was their beleif?"
    },
    "170": {
        "startTime": 1062.866,
        "endTime": 1064.732,
        "transcript": "Yupiat? (Ii-i.)",
        "translation": "The Yup'ik people? (Yes.)"
    },
    "171": {
        "startTime": 1065.387,
        "endTime": 1073.231,
        "transcript": "Camek ukverunateng imkut waten qanernaurtut, imkut tamakut magic-aat-wa Kass'atum apeqmeggnek:",
        "translation": "Without any belief, they would say this about what they call magic in English:"
    },
    "172": {
        "startTime": 1073.249,
        "endTime": 1075.949,
        "transcript": "Ellam-gguq Yua. Ellam-gguq Yua.",
        "translation": "They called it the Spirit of the Universe."
    },
    "173": {
        "startTime": 1075.96,
        "endTime": 1077.438,
        "transcript": "Cunaw' Agayun.",
        "translation": "Turned out to be God."
    },
    "174": {
        "startTime": 1078.088,
        "endTime": 1082.165,
        "transcript": "Ellam-gguq Yuanek qigciyugluteng tuaten pitullruut.",
        "translation": "They said they would do that, respecting the Spirit of the Universe."
    },
    "175": {
        "startTime": 1083.912,
        "endTime": 1086.045,
        "transcript": "Cunaw' God-amek.",
        "translation": "Tuned out to be God."
    },
    "176": {
        "startTime": 1086.932,
        "endTime": 1091.255,
        "transcript": "Ellam Yuanek apraqluku God-aq.",
        "translation": "They referred to God as the Spirit of the Universe."
    },
    "177": {
        "startTime": 1094.342,
        "endTime": 1098.831,
        "transcript": "Imkut-qaa yugurluut tuunrangayagmek qanlallruut?",
        "translation": "Would the people of old speak about the devil?"
    },
    "178": {
        "startTime": 1098.839,
        "endTime": 1100.45,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "179": {
        "startTime": 1101.443,
        "endTime": 1105.087,
        "transcript": "Tuaten tuunrangayagmek qanyuitellruut yugurluut.",
        "translation": "The people of old didn't speak about the devil like that."
    },
    "180": {
        "startTime": 1105.318,
        "endTime": 1110.262,
        "transcript": "Tau͡gken angalkuugaqluteng tuunrituluteng wiinga-ll' tangvagaqlua.",
        "translation": "Yet they would be shamans who called on their spirit helpers, and I would watch."
    },
    "181": {
        "startTime": 1110.409,
        "endTime": 1118.198,
        "transcript": "Qaill' tang ciin atak piaqluteng wiinga-ll' qaillun piciitaqluki tamakut.",
        "translation": "You see, they would do things for some reason, and I wouldn't know what they did."
    },
    "182": {
        "startTime": 1118.201,
        "endTime": 1118.868,
        "transcript": "Tangvallruaten?",
        "translation": "Did you watch them?"
    },
    "183": {
        "startTime": 1118.884,
        "endTime": 1120.573,
        "transcript": "Tangvagaqluki.",
        "translation": "I would watch them."
    },
    "184": {
        "startTime": 1120.578,
        "endTime": 1122.367,
        "transcript": "Qaill' pilallruat?",
        "translation": "What would they do?"
    },
    "185": {
        "startTime": 1122.416,
        "endTime": 1126.638,
        "transcript": "Tua-i piluteng piaqluteng.",
        "translation": "They would do [whatever] they did."
    },
    "186": {
        "startTime": 1126.648,
        "endTime": 1129.87,
        "transcript": "Tua-i taq'ertaqameng qalartaqluteng.",
        "translation": "When they stopped, they would speak."
    },
    "187": {
        "startTime": 1129.88,
        "endTime": 1133.569,
        "transcript": "Ella-llu-gguq kitugtaqluku, ellaliuraqluteng-llu.",
        "translation": "They said that they fixed and predicted the weather."
    },
    "188": {
        "startTime": 1134.187,
        "endTime": 1138.109,
        "transcript": "Iralurtaqluteng-llu-gguq wanirpapiaq tua-i.",
        "translation": "They also said they'd instantly go to the moon."
    },
    "189": {
        "startTime": 1138.755,
        "endTime": 1144.877,
        "transcript": "Tang qaill' yuut ayuqellruut. Ircenrrartun ayuqellruut yuut wani.",
        "translation": "You see, people were strange. People were like legendary little people."
    },
    "190": {
        "startTime": 1146.277,
        "endTime": 1147.332,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "191": {
        "startTime": 1147.369,
        "endTime": 1155.069,
        "transcript": "Tuamtellu yuk waten cavvnaurait tamakut, akngirutii cakneq cavvluku.",
        "translation": "Then they would feel a person like this, feeling for his extreme pain."
    },
    "192": {
        "startTime": 1155.37,
        "endTime": 1158.17,
        "transcript": "Tua-i-ll' pegeskatni assiriluni.",
        "translation": "Then when they let go of him, he got better."
    },
    "193": {
        "startTime": 1158.745,
        "endTime": 1163.445,
        "transcript": "Qaillun tamakut yuut? Irr'inarqut tamakut yullret.",
        "translation": "How did those people [do it]? Those people of old are amazing."
    },
    "194": {
        "startTime": 1167.609,
        "endTime": 1170.48,
        "transcript": "Akilircetaarluteng-qaa tuaten pilallruut?",
        "translation": "Would they ask to be paid to do that?"
    },
    "195": {
        "startTime": 1170.48,
        "endTime": 1172.68,
        "transcript": "Nuu, akilircetaayuitait.",
        "translation": "No, they didn't ask to be paid."
    },
    "196": {
        "startTime": 1172.689,
        "endTime": 1176.1,
        "transcript": "Tau͡gaam imkut tamakut tuunritulit",
        "translation": "But those people who called on spirit helpers"
    },
    "197": {
        "startTime": 1178.044,
        "endTime": 1189.267,
        "transcript": "Tauna-ll' yuk cateng anirtuusqumaaqamegteggu canek piciatun, Kass'artarnek akluitellruameng, Yugtarrlainarnek tau͡gaam pingqellruameng",
        "translation": "When they wanted that person, their relative, to be saved, [they brought] various things, because they didn't have Western clothes because they only had Yup'ik things"
    },
    "198": {
        "startTime": 1189.714,
        "endTime": 1195.525,
        "transcript": "Camek, makliim-llu qecianek, maklaaraam-llu qecianek",
        "translation": "Something, including a bearded seal skin, and a young bearded seal skin"
    },
    "199": {
        "startTime": 1195.862,
        "endTime": 1203.906,
        "transcript": "Piciatun tua-i wani terikaniarmek, keglunermek",
        "translation": "Various things, wolverine skin, wolf skin"
    },
    "200": {
        "startTime": 1204.458,
        "endTime": 1209.703,
        "transcript": "Tua-i camek tuaten ayuqellruut tamakut yuut.",
        "translation": "[Giving] something, that's what those people were like."
    },
    "201": {
        "startTime": 1210.909,
        "endTime": 1216.953,
        "transcript": "Tua-i akiutekluki tamakut cam [?].",
        "translation": "That was their payment, [?skin] of something."
    },
    "202": {
        "startTime": 1217.309,
        "endTime": 1221.998,
        "transcript": "Akiuteklu[ki]. Akimek nalluq'apiarluteng tua-i.",
        "translation": "That was their payment. They knew nothing about money."
    },
    "203": {
        "startTime": 1224.125,
        "endTime": 1232.758,
        "transcript": "Tamaani-qaa ayagyuallerpeni ayagalallerpeni pissurluten wall'u-qaa natmun ayagaqavet",
        "translation": "Back when you were young, when you traveled to go hunting, or when you traveled somewhere"
    },
    "204": {
        "startTime": 1233.107,
        "endTime": 1237.651,
        "transcript": "Elpet-qaa camek irr'inarqellriamek...",
        "translation": "Did you [experience] anything amazing?"
    }
};